<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Hawaii State Environmental Health Administration Solid and Hazardous Waste Branch"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop class="grid grid-cols-1 gap-10 2xl:col-span-2 2xl:grid-cols-2">
        <PublicLandingOnlineServices
          class="2xl:col-span-2"
          title="Employee Services"
          body="The Underground Storage Tank System provides online employee access to program facilities, tanks, permits, suspected and confirmed release events, and compliance events."
          hide-register
        ></PublicLandingOnlineServices>

        <PublicLandingCard>
          <PublicLandingCardSection label="Facilities">
            <PublicLandingParagraph>Find, view, and manage UST facilities.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage facility locations, notification forms, and dispensers" />
              <PublicLandingListItem label="Monitor facility release and compliance events" />
              <PublicLandingListItem label="Track underground storage tanks and activities" />
            </PublicLandingList>
          </PublicLandingCardSection>
          <PublicLandingCardSection label="Tanks">
            <PublicLandingParagraph>Find, view, and manage underground storage tanks.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage tank locations" />
              <PublicLandingListItem label="Track tank permitting activities" />
              <PublicLandingListItem label="Monitor tank status and releases" />
            </PublicLandingList>
          </PublicLandingCardSection>
          <PublicLandingCardSection label="Permits">
            <PublicLandingParagraph>Find, view, and manage UST permits.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage new permits and permit renewals" />
              <PublicLandingListItem label="Track permitted underground storage tanks" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>

        <PublicLandingCard>
          <PublicLandingCardSection label="Release Events">
            <PublicLandingParagraph>Find, view, and manage UST release events.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage facility suspected and confirmed releases" />
              <PublicLandingListItem label="Track confirmed release event responses" />
              <PublicLandingListItem label="Monitor release status changes and event timeline" />
            </PublicLandingList>
          </PublicLandingCardSection>
          <PublicLandingCardSection label="Compliance Events">
            <PublicLandingParagraph>Find, view, and manage UST compliance events.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Manage compliance events, including inspections" />
              <PublicLandingListItem label="Track deficiencies and issues" />
              <PublicLandingListItem label="Monitor inspection items until resolved" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { computed, defineComponent } from "vue";

import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import { routeNames } from "@/routes";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore, routeNames };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    RegisterButton,
    MdrnFooter,
    NoneFoundFlag,
    LogoutButton,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingLinkCard,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #363a3d; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/bg-ust.webp");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
